<template>
  <a-alert
    type="warning"
    message="ESSE COMPROMISSO É REALIZADO AUTOMATICAMENTE PELO SISTEMA"
    show-icon
  />
</template>
